import type { ComponentProps, ReactElement } from "react";

import { ComposerCreditGateNotice } from "./composerCreditGateView";
import { ComposerPendingElementContexts } from "./ComposerPendingElementContexts";
import { ComposerPromptLengthValidation } from "./ComposerPromptLengthValidation";

/**
 * The rows between the prompt and the footer: what the next send will carry,
 * and what would stop it.
 *
 * Below the prompt rather than above it, and not a toast. All three answer a
 * question the person has just after typing, so they land where the eye already
 * is, and none of them displaces the send button.
 *
 * Kept out of `ChatComposer` because that file is at its size cap and this is a
 * pure render of props. It also stays in flow while the Composer rests: a
 * blocked send is not something to hide behind a layout change.
 */
export function ChatComposerBelowPrompt({
  browserCommentTarget,
  promptLengthError,
  creditGate,
  onClearBrowserCommentTarget,
}: {
  readonly browserCommentTarget: ComponentProps<typeof ComposerPendingElementContexts>["target"];
  readonly promptLengthError: string | null;
  readonly creditGate: ComponentProps<typeof ComposerCreditGateNotice>["decision"];
  readonly onClearBrowserCommentTarget: () => void;
}): ReactElement {
  return (
    <>
      <ComposerPendingElementContexts
        target={browserCommentTarget}
        className="px-3 pb-2 sm:px-4"
        onRemove={onClearBrowserCommentTarget}
      />
      <ComposerPromptLengthValidation message={promptLengthError} />
      <ComposerCreditGateNotice decision={creditGate} />
    </>
  );
}
